export const processingSteps = {
  label: "Folgearbeitsschritte",
  processingStepsFor: "Folgearbeitsschritte für {name}",
  noProcessingSteps: "Keine Folgearbeiten festgelegt",
  configureProcessingSteps: "Bauteil konfigurieren",
  quantity: "Anzahl",
  notWorkingDemoVersion: "(nicht funktionale Demoversion)",
  inputLabels: {
  },
  actionLabels: {
    saveConfiguration: "Speichern",
    addStep: "Hinzufügen",
  },
};
